/**
 * Devices API adapter for web-app
 *
 * Exposes the mango-api-client devices resource for use with DevicesApiProvider.
 */
import { getMangoApiClient } from '~/atoms/MangoApi'

import type { DevicesApi } from '@mangovoice/devices-ui'

export const getDevicesApi = (): DevicesApi => getMangoApiClient().devices

export const devicesApi: DevicesApi = new Proxy({} as DevicesApi, {
  get(_target, prop, receiver) {
    return Reflect.get(getDevicesApi(), prop, receiver)
  },
})
